import "../../../assets/css/VideoConference.css";
import { FiAlertCircle, FiCheckCircle, FiLogOut } from "react-icons/fi";
import PrimaryButton from "../../../components/common/PrimaryButton";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REDIRECT_URI =
  process.env.REACT_APP_GOOGLE_REDIRECT_URI ||
  `${window.location.origin}/google/callback`;

export default function GoogleAuthSection({ connected, onDisconnect }) {
  const connectGoogle = () => {
    // `flow: "meet"` tags this OAuth round-trip so the shared GoogleCallback.js page
    // knows to use the server-side (BFF) exchange instead of Gmail's legacy raw-token one.
    const state = JSON.stringify({ origin: window.location.origin, flow: "meet" });

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?response_type=code` +
      `&client_id=${CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&scope=https://www.googleapis.com/auth/calendar.events` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`;

    window.open(url, "Google OAuth", "width=500,height=650");
  };

  const logout = async () => {
    await onDisconnect();
  };

  /* ---------------- DISCONNECTED ---------------- */
  if (!connected) {
    return (
      <div className="zoom-auth-wrapper">
        <div className="zoom-auth-card warning">
          <div className="zoom-auth-left">
            <div className="zoom-auth-icon warning-icon">
              <FiAlertCircle />
            </div>

            <div>
              <div className="zoom-auth-heading">
                Connect Your Account
              </div>
              <div className="zoom-auth-subtext">
                Authenticate with Google to create and manage meetings
              </div>
            </div>
          </div>

          <PrimaryButton
            className="zoom-auth-btn"
            onClick={connectGoogle}
          >
            Connect Google
          </PrimaryButton>
        </div>
      </div>
    );
  }

  /* ---------------- CONNECTED ---------------- */
  return (
    <div className="zoom-auth-wrapper">
      <div className="zoom-auth-card success">
        <div className="zoom-auth-left">
          <div className="zoom-auth-icon success-icon">
            <FiCheckCircle />
          </div>

          <div>
            <div className="zoom-auth-heading">
              Connected
            </div>
            <div className="zoom-auth-subtext muted">
              Your Google Meet account is connected
            </div>
          </div>
        </div>

        <button
          className="zoom-auth-logout"
          onClick={logout}
        >
          <FiLogOut /> Sign Out
        </button>
      </div>
    </div>
  );
}
